interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages: (number | string)[] = [];
  for (let i = 1; i <= total; i += 1) {
    if (i === 1 || i === total || (i >= current - 1 && i <= current + 1)) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== '...') {
      pages.push('...');
    }
  }

  return (
    <div className="flex items-center justify-center gap-1.5 flex-wrap">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className="w-9 h-9 flex items-center justify-center rounded-md border border-background-300 text-foreground-700 hover:border-accent-400 hover:text-accent-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer"
        aria-label="上一页"
      >
        <i className="ri-arrow-left-s-line text-lg"></i>
      </button>

      {pages.map((p, idx) =>
        typeof p === 'number' ? (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            className={`min-w-9 h-9 px-2 flex items-center justify-center rounded-md text-sm font-medium transition-colors cursor-pointer ${
              p === current
                ? 'bg-primary-500 text-background-50'
                : 'border border-background-300 text-foreground-700 hover:border-accent-400 hover:text-accent-700'
            }`}
          >
            {p}
          </button>
        ) : (
          <span key={`gap-${idx}`} className="w-9 h-9 flex items-center justify-center text-foreground-400">
            …
          </span>
        )
      )}

      <button
        type="button"
        onClick={() => onChange(Math.min(total, current + 1))}
        disabled={current === total}
        className="w-9 h-9 flex items-center justify-center rounded-md border border-background-300 text-foreground-700 hover:border-accent-400 hover:text-accent-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer"
        aria-label="下一页"
      >
        <i className="ri-arrow-right-s-line text-lg"></i>
      </button>
    </div>
  );
}